<script>
import CalendarProgressMobile from '@components/progress/calendar-progress-mobile.vue';
import { homeComputed, authComputed, orgComputed } from '@state/helpers';
import moment from 'moment';

export default {
  components: {
    CalendarProgressMobile,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...homeComputed,
    ...authComputed,
    ...orgComputed,
    metrics() {
      return this.progressDetails && this.progressDetails.metrics;
    },
    workoutHistory() {
      return this.progressDetails && this.progressDetails.workoutHistory;
    },
    weeks() {
      return this.progressDetails && this.progressDetails.weeks;
    },
    progressHours() {
      return this.metrics && this.metrics.totalWorkoutDurationSeconds
        ? (this.metrics.totalWorkoutDurationSeconds / 3600).toFixed(1)
        : 0;
    },
    userAvatar() {
      return this.userProfile &&
        this.userProfile.mediaAssets &&
        this.userProfile.mediaAssets.avatarImage &&
        this.userProfile.mediaAssets.avatarImage.url
        ? this.userProfile.mediaAssets.avatarImage.url
        : require('@assets/images/placeholder-avatar.png');
    },
    cssVars() {
      return {
        '--color': this.primaryColor,
      };
    },
  },
  mounted() {},
  methods: {
    toProfile() {
      this.$router.push({ name: 'Info' });
    },
    toHome() {
      this.$router.push({ name: 'home' });
    },
    getDate(date) {
      if (moment.utc(date).isSame(moment.utc(), 'day')) {
        return 'Today';
      } else {
        return moment.utc(date).format('MMMM D');
      }
    },
  },
};
</script>

<template>
  <div class="progress-container" :style="cssVars">
    <div class="mobile-header">
      <span>
        <div @click="$router.push({ name: 'home' })">
          <BaseIcon class="icon-arrow" name="arrow-left" />
        </div>
      </span>
      <span class="header-title">Progress</span>
      <img @click="toProfile" :src="userAvatar" />
    </div>
    <div v-if="homeOverview && !homeOverview.isProgramEmpty" class="progress-program-completion">
      <div class="content">
        <div class="progress-numbers row">
          <div class="col">
            <div class="num">
              {{ metrics && metrics.workoutsCompleted ? metrics.workoutsCompleted : 0 }}
            </div>
            <span>WORKOUTS</span>
          </div>
          <span class="divider-vertical">&nbsp;</span>
          <div class="col">
            <div class="num">
              {{ metrics && metrics.exercisesCompleted ? metrics.exercisesCompleted : 0 }}
            </div>
            <span>EXERCISES</span>
          </div>
          <span class="divider-vertical">&nbsp;</span>
          <div class="col">
            <div class="num">
              {{ progressHours }}
            </div>
            <span>HOURS</span>
          </div>
        </div>
        <CalendarProgressMobile :weeks="weeks" />
        <div class="history">
          <div class="title row">
            <h3>My History</h3>
          </div>
          <template v-for="workout in workoutHistory">
            <div class="item row" :key="workout.date">
              <h3>{{ workout.label }}</h3>
              <span class="date">{{ getDate(workout.date) }}</span>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.progress-container {
  .mobile-header {
    align-items: center;
    display: grid;
    font-size: 18px;
    grid-column-end: 3;
    grid-column-start: 1;
    grid-row-end: 1;
    grid-row-start: 1;
    grid-template-columns: repeat(3, 1fr);
    padding-left: 2.5rem;
    padding-right: 2.5rem;
    padding-top: 40px;
    span {
      div {
        height: fit-content;
        width: fit-content;
      }
    }
    .header-title {
      color: #000;
      font-family: $roboto;
      font-weight: 500;
      text-align: center;
      text-transform: capitalize;
    }
    img {
      border-radius: 50%;
      height: 35px;
      justify-self: flex-end;
      object-fit: cover;
      width: 35px;
    }
  }
  .progress-program-completion {
    align-items: center;
    color: var(--color);
    display: flex;
    flex: 1;
    flex-direction: column;
    font-size: 11px;
    font-style: normal;
    font-weight: 800;
    justify-content: center;
    letter-spacing: 0.0916667px;
    line-height: 22px;
    padding-bottom: 7rem;
    padding-top: 1rem;
    position: relative;
    text-transform: uppercase;
    .content {
      width: 100%;
      .progress-numbers {
        align-items: center;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-evenly;
        margin-left: auto;
        margin-right: auto;
        max-width: 60rem;
        padding: 4rem 1rem 4rem 1rem;
        width: 90%;
        .divider-vertical {
          border-left: 1px solid rgba(#000, 0.3);
          height: 4.7rem;
          opacity: 0.4;
        }
        .col {
          align-items: flex-start;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;
          .num {
            @include calc-font-size(3.3);

            margin-bottom: 0.5rem;
          }
          span {
            color: #8f8f8f;
            @include calc-font-size(1.2);
          }
        }
      }
      .history {
        padding-bottom: 2rem;
        padding-left: 2.5rem;
        padding-right: 2.5rem;
        text-transform: capitalize;
        .title {
          margin-left: unset;
          margin-right: unset;
          padding-bottom: 0.5rem;
          padding-top: 3rem;
          h3 {
            font-family: $base-font-family;
            font-size: 18px;
            font-style: normal;
            font-weight: bold;
            line-height: 25px;
          }
        }
        .item {
          align-items: center;
          display: flex;
          justify-content: space-between;
          margin-left: unset;
          margin-right: unset;
          padding-bottom: 2rem;
          padding-top: 2rem;
          &:not(:last-child) {
            border-bottom: 1px solid rgba(#000, 0.1);
          }
          h3 {
            font-family: $proxima-nova;
            font-size: 17px;
            font-style: normal;
            font-weight: normal;
            line-height: 19px;
            margin-bottom: unset;
          }
          .date {
            color: #000;
            font-family: $proxima-nova;
            font-size: 14px;
            font-style: normal;
            font-weight: 300;
            line-height: 17px;
            opacity: 0.5;
            text-align: right;
          }
        }
      }
    }
  }
}

.loading-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 30vh;
  position: absolute;
  width: 100%;

  ::v-deep .loading {
    height: 5rem;
    width: 5rem;
  }
}
</style>
